export const a4_vertical = {
    "paper": {
        "id": 3,
        "name": "A4タテ-両面",
    },
    "paper_type": {
        "id": 3,
    },
    "name": "無題のテンプレート",
    "template_id_parent": 7,
    "template_pages": [
        {
            "id": 13,
            "page_name": "通信面",
            "page_type": 1,
            "page_order": 1,
            "svg_content": "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" height=\"3578.43\" width=\"2550.96\"></svg>",
            "thumbnail_path": "https://posto-public-develop.s3.ap-northeast-1.amazonaws.com/template_thumbnails/plane_template/A4_double_vertical_cs.png",
            "is_editable": 1,
            "bleed_line_width": 216,
            "bleed_line_height": 303,
            "crop_line_width": 210,
            "crop_line_height": 297,
            "safety_line_width": 204,
            "safety_line_height": 291,
            "finished_width": 210,
            "finished_height": 297,
            "bleed_line_width_pixel": 2551,
            "bleed_line_height_pixel": 3578,
            "crop_line_width_pixel": 2480,
            "crop_line_height_pixel": 3508,
            "safety_line_width_pixel": 2409,
            "safety_line_height_pixel": 3437,
            "finished_width_pixel": 2480,
            "finished_height_pixel": 3508,
            "detail": null,
            "template_page_tracking_urls": [],
            "created_at": "2019-04-01 16:32:13",
            "updated_at": "2019-04-01 16:32:13",
            "deleted_at": null
        },
        {
            "id": 14,
            "page_name": "宛名面",
            "page_type": 2,
            "page_order": null,
            "svg_content": "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 2551 3579\" style=\"enable-background:new 0 0 2551 3579;\" xml:space=\"default\">\n</svg>\n",
            "thumbnail_path": "https://posto-public-develop.s3.ap-northeast-1.amazonaws.com/template_thumbnails/plane_template/A4_double_vertical_as.png",
            "is_editable": 1,
            "bleed_line_width": 216,
            "bleed_line_height": 303,
            "crop_line_width": 210,
            "crop_line_height": 297,
            "safety_line_width": 204,
            "safety_line_height": 291,
            "finished_width": 210,
            "finished_height": 297,
            "bleed_line_width_pixel": 2551,
            "bleed_line_height_pixel": 3578,
            "crop_line_width_pixel": 2480,
            "crop_line_height_pixel": 3508,
            "safety_line_width_pixel": 2409,
            "safety_line_height_pixel": 3437,
            "finished_width_pixel": 2480,
            "finished_height_pixel": 3508,
            "detail": {
                "first_position_x": 96,
                "first_position_y": 940
            },
            "template_page_tracking_urls": [],
            "created_at": "2019-04-01 16:32:13",
            "updated_at": "2019-04-01 16:32:13",
            "deleted_at": null
        }
    ],
    'dpi': 72,
    'inch_mm_ratio': 25.4,
}



// WEBPACK FOOTER //
// ./src/constants/a4-vertical.js